import gsap from 'gsap'
import Base from '../../../src/js/classes/Base'

export default class WholesaleApplicationForm extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				closes: '.c-WholesaleApplicationForm__controls__close',
			},
			options: {},
			classes: {
				wholesaleOpen: 'wholesale-open',
			},
			state: {},
		})
	}

	init() {
		this.elements.closes = gsap.utils.toArray(this.elements.closes)
		this.addEvents()
	}

	addEvents() {
		this.elements.closes.forEach((close) => {
			close.addEventListener('click', this.onClickClose.bind(this))
		})
	}

	onClickClose(e) {
		e.preventDefault()
		document.body.classList.remove(this.classes.wholesaleOpen)
	}

	removeEvents() {
		this.elements.closes.forEach((close) => {
			close.removeEventListener('click', this.onClickClose.bind(this))
		})
	}

	resize() {}

	update() {}

	unmount() {
		this.removeEvents()
	}
}
